import { dateTimeToView } from "helpers/date";
import { divIcon } from "leaflet";
import React, { useEffect, useState } from "react";
import { Marker, Tooltip } from "react-leaflet";
import { getControlPoints } from "sources/driverJobs";

const BidControlPoints = (props) => {
    const { bidId } = props;
    const [points, setPoints] = useState([]);
    const icon = divIcon({ className: "map-icon--control-point", iconSize: [22, 22] });

    useEffect(() => {
        getControlPoints(bidId).then(setPoints);
    }, []);

    return points.map((point) => (
        <Marker key={point.id} position={[...point.coordinate].reverse()} icon={icon}>
            <Tooltip className="map__tooltip-route-marker map__tooltip--default" direction="top">
                Контрольная точка
                {point.visitedAt && (
                    <>
                        <br />
                        Время посещения точки: {dateTimeToView(point.visitedAt)}
                    </>
                )}
            </Tooltip>
        </Marker>
    ));
};

export default BidControlPoints;
